import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { PublicAssetProductState } from '../types';

const setAbstractProductReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<AppBundle.Api.Entity.App.V1.IAbstractProduct | undefined>,
) => {
  const product = action.payload;
  if (!product) {
    return;
  }
  state.abstractProducts[product.slug] = product;
};

export default setAbstractProductReducer;
